var _defs, _path, _path2, _polyline, _polyline2, _path3, _path4, _polyline3, _path5, _path6, _path7, _path8, _polyline4, _path9, _path10, _path11, _path12, _path13, _path14, _polyline5, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _polyline6, _path28, _path29, _path30, _path31, _path32, _polyline7, _polyline8, _polyline9, _polyline10, _polyline11, _polyline12, _polyline13, _polyline14, _polyline15, _polyline16, _polyline17, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _polyline18, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _polyline19, _path84, _path85, _polyline20, _path86, _path87, _path88, _path89, _polyline21, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _polyline22, _polyline23, _polyline24, _path99, _path100, _path101, _path102, _path103, _path104, _polyline25, _polyline26, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _polyline27, _polyline28, _polyline29, _polyline30, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _polyline31, _path134, _path135, _path136, _path137, _polyline32, _polyline33, _path138, _polyline34, _polyline35, _path139, _polyline36, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _polyline37, _path156, _polyline38, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _polyline39, _path168, _polyline40, _path169, _polyline41, _path170, _path171, _path172, _path173, _path174, _polyline42, _path175, _polyline43, _path176, _polyline44, _path177, _path178, _path179, _polyline45, _path180, _path181, _path182, _path183, _path184, _path185, _polyline46, _path186, _polyline47, _polyline48, _polyline49, _polyline50, _polyline51, _polyline52, _polyline53, _path187, _polyline54, _polyline55, _polyline56, _polyline57, _polyline58, _polyline59, _polyline60, _polyline61, _polyline62, _path188, _polyline63, _polyline64, _polyline65, _polyline66, _path189, _path190, _path191, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWord = function SvgWord(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 33.49",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#061634;}.cls-2{fill:#061734;}.cls-3{fill:#061735;}.cls-4{fill:#061736;}.cls-5{fill:#fff;}.cls-6{fill:#b9b9b9;}.cls-7{fill:#2f77ab;}.cls-8{fill:#317db5;}.cls-9{fill:#aeaeae;}.cls-10{fill:#bebebe;}.cls-11{fill:#cacaca;}.cls-12{fill:#cbcbcb;}.cls-13{fill:#afafaf;}.cls-14{fill:#123458;}.cls-15{fill:#143961;}.cls-16{fill:#123357;}.cls-17{fill:#113052;}.cls-18{fill:#113051;}.cls-19{fill:#113053;}.cls-20{fill:#134795;}.cls-21{fill:#13385f;}.cls-22{fill:#113255;}.cls-23{fill:#113256;}.cls-24{fill:#13375e;}.cls-25{fill:#113154;}.cls-26{fill:#113153;}.cls-27{fill:#102e4f;}.cls-28{fill:#102e4e;}.cls-29{fill:#102f50;}.cls-30{fill:#102f51;}.cls-31{fill:#102d4c;}.cls-32{fill:#102d4d;}.cls-33{fill:#12365a;}.cls-34{fill:#12355a;}.cls-35{fill:#123559;}.cls-36{fill:#12438c;}.cls-37{fill:#103f91;}.cls-38{fill:#102c4b;}.cls-39{fill:#184676;}.cls-40{fill:#183c57;}.cls-41{fill:#183d59;}.cls-42{fill:#183d58;}.cls-43{fill:#245d85;}.cls-44{fill:#2469b2;}.cls-45{fill:#173b55;}.cls-46{fill:#173c56;}.cls-47{fill:#16416e;}.cls-48{fill:#163e6a;}.cls-49{fill:#245c85;}.cls-50{fill:#1651ab;}.cls-51{fill:#205074;}.cls-52{fill:#1f4e70;}.cls-53{fill:#1d548f;}.cls-54{fill:#1e4c6e;}.cls-55{fill:#22567c;}.cls-56{fill:#215377;}.cls-57{fill:#215378;}.cls-58{fill:#205c9c;}.cls-59{fill:#205175;}.cls-60{fill:#09234f;}.cls-61{fill:#092351;}.cls-62{fill:#092350;}.cls-63{fill:#09234a;}.cls-64{fill:#092044;}.cls-65{fill:#092043;}.cls-66{fill:#092246;}.cls-67{fill:#092248;}.cls-68{fill:#092145;}.cls-69{fill:#092146;}.cls-70{fill:#092454;}.cls-71{fill:#092554;}.cls-72{fill:#092452;}.cls-73{fill:#081e46;}.cls-74{fill:#081e45;}.cls-75{fill:#082049;}.cls-76{fill:#081f47;}.cls-77{fill:#08224c;}.cls-78{fill:#08214c;}.cls-79{fill:#2262a6;}.cls-80{fill:#40a4ec;}.cls-81{fill:#41a5ee;}.cls-82{fill:#3f9fe6;}.cls-83{fill:#3e9ee4;}.cls-84{fill:#071c3e;}.cls-85{fill:#071c3f;}.cls-86{fill:#071c41;}.cls-87{fill:#071d43;}.cls-88{fill:#071a3b;}.cls-89{fill:#071a3c;}.cls-90{fill:#071a3d;}.cls-91{fill:#071b3e;}.cls-92{fill:#071b3f;}.cls-93{fill:#061838;}.cls-94{fill:#061837;}.cls-95{fill:#06193b;}.cls-96{fill:#061939;}.cls-97{fill:#154ca0;}.cls-98{fill:#153d67;}.cls-99{fill:#0b2a60;}.cls-100{fill:#0b2b62;}.cls-101{fill:#0b2854;}.cls-102{fill:#0b2d68;}.cls-103{fill:#0b295d;}.cls-104{fill:#0a2758;}.cls-105{fill:#0a275a;}.cls-106{fill:#0a244b;}.cls-107{fill:#0a2658;}.cls-108{fill:#0a244c;}.cls-109{fill:#0a2349;}.cls-110{fill:#0a254e;}.cls-111{fill:#0a295d;}.cls-112{fill:#0a295c;}.cls-113{fill:#0a2650;}.cls-114{fill:#0a285b;}.cls-115{fill:#0f2c4b;}.cls-116{fill:#193f5b;}.cls-117{fill:#0f3d8c;}.cls-118{fill:#0e326a;}.cls-119{fill:#0f3875;}.cls-120{fill:#0f3b87;}.cls-121{fill:#0e377e;}.cls-122{fill:#0e3983;}.cls-123{fill:#1d4a6a;}.cls-124{fill:#1d4a6b;}.cls-125{fill:#1c4665;}.cls-126{fill:#1c4868;}.cls-127{fill:#1c4766;}.cls-128{fill:#3586c1;}.cls-129{fill:#368ac7;}.cls-130{fill:#368ac8;}.cls-131{fill:#0b2e67;}.cls-132{fill:#1b4463;}.cls-133{fill:#1b4462;}.cls-134{fill:#185abd;}.cls-135{fill:#1a4360;}.cls-136{fill:#1a415e;}.cls-137{fill:#19497c;}.cls-138{fill:#194779;}.cls-139{fill:#1757b6;}.cls-140{fill:#0d2f63;}.cls-141{fill:#0d3273;}.cls-142{fill:#0d2d5f;}.cls-143{fill:#0d357a;}.cls-144{fill:#0d3476;}.cls-145{fill:#0c306e;}.cls-146{fill:#0c306f;}.cls-147{fill:#0c2f6c;}.cls-148{fill:#3c99dc;}.cls-149{fill:#0c2e60;}.cls-150{fill:#0c2c5d;}.cls-151{fill:#1c5189;}.cls-152{fill:#1b4d83;}.cls-153{fill:#1b4564;}.cls-154{fill:#1b4563;}.cls-155{fill:#286693;}.cls-156{fill:#286793;}.cls-157{fill:#2770bf;}.cls-158{fill:#2a6b9a;}.cls-159{fill:#2a78cc;}.cls-160{fill:#2c71a2;}.cls-161{fill:#2c70a1;}.cls-162{fill:#296896;}.cls-163{fill:#2b7cd3;}.cls-164{fill:#3483bd;}.cls-165{fill:#3a94d6;}.cls-166{fill:#3a94d5;}.cls-167{fill:#378cc9;}.cls-168{fill:#3382bb;}.cls-169{fill:#3382bc;}.cls-170{fill:#3381bb;}.cls-171{fill:#3b95d7;}.cls-172{fill:#307bb0;}.cls-173{fill:#255e88;}.cls-174{fill:#27638f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m10.5,0h23.99c.82,0,1.5.71,1.51,1.61v30.28c0,.89-.68,1.61-1.51,1.6H10.5c-.4,0-.78-.17-1.07-.47-.28-.3-.44-.71-.44-1.13V1.61c0-.43.16-.84.44-1.14C9.73.18,10.11.01,10.5,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m36,25.12H9v6.76c0,.89.68,1.61,1.51,1.6h23.99c.82.01,1.5-.7,1.51-1.6v-6.76"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-134",
    points: "9 16.75 36 16.75 36 25.12 9 25.12 9 16.75"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-163",
    points: "9 8.38 36 8.38 36 16.75 9 16.75 9 8.38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m19.68,16.75h-.44s.44,0,.44,0h0m-1.11-9.91h-.74c.07.11.12.24.15.38h.15c.6,0,1.09.51,1.11,1.16h.44v-.3c0-.66-.48-1.2-1.09-1.2h-.03v-.04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "m19.68,25.12h-.44v.72c0,.07,0,.13-.02.19v.14c0,.1-.02.2-.04.29.3-.22.49-.58.5-1v-.35"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-139",
    points: "19.68 16.75 19.24 16.75 19.24 25.12 19.68 25.12 19.68 16.75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "m19.68,8.38h-.44s0,.02,0,.03v8.34h.44v-8.37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m9,25.74v3.45h7.51c.77,0,1.4-.64,1.46-1.47-.06.02-.11.05-.17.06-.25.49-.73.82-1.28.82h-7.52v-2.87h0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "m19.24,16.75h-.02s.02,0,.02,0h0m-1.11-9.53h-.15c.02.09.03.18.03.28v.22h.1c.43,0,.81.27.99.66h.14c-.02-.65-.51-1.16-1.11-1.16"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "m19.24,25.12h-.02v.91c0-.06.02-.13.02-.19v-.72"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-50",
    points: "19.24 16.75 19.23 16.75 19.23 25.12 19.24 25.12 19.24 16.75"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "m19.24,8.38h-.14c.07.16.12.34.12.53v7.85h.02v-8.34s0-.02,0-.03"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m19.19,26.47c-.06.04-.12.08-.18.11-.1.14-.23.26-.38.34-.03.14-.09.26-.16.37.35-.12.62-.43.72-.82"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "m19.23,26.04c-.03.2-.11.38-.22.53.06-.03.12-.06.18-.11.02-.09.04-.19.04-.29v-.14"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "m19.01,26.57c-.11.05-.23.08-.35.09,0,.08-.02.17-.04.25.15-.08.28-.2.38-.34"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "m19.23,16.75h-.19s.19,0,.19,0h0m-1.11-9.04h-.1v.1h0v.32h0v.13c.14.01.27.05.39.11h.7c-.18-.39-.56-.66-1-.66"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "m19.23,25.12h-.19v.63h0c0,.37-.15.68-.38.9,0,0,0,.01,0,.02.12-.01.24-.04.35-.09.11-.15.19-.33.22-.53v-.92"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-97",
    points: "19.23 16.75 19.04 16.75 19.04 25.12 19.23 25.12 19.23 16.75"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m19.11,8.38h-.7c.37.19.63.6.63,1.08v7.29h.19v-7.85c0-.19-.05-.37-.12-.53"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m16.91,6.31h0s-.02,0-.03,0h-.04s-7.82,0-7.82,0v1.08h0v-.75h7.88c.23,0,.45.08.63.21h.31c-.2-.32-.53-.54-.92-.54"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m17.83,6.84h-.31c.13.1.25.23.33.38h.13c-.03-.14-.08-.26-.15-.38"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "m17.98,7.22h-.13c.08.15.14.32.16.5h0v-.22c0-.1-.01-.19-.03-.28"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "m18.01,7.72h0s0,.07,0,.1v-.1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "m17.8,27.78c-.08.02-.16.03-.25.03h-.22c-.23.17-.51.27-.81.27h-7.51v.53h7.52c.55,0,1.03-.33,1.28-.83"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "m9,25.74v2.34h7.51c.3,0,.58-.1.81-.27h-7.6c-.14,0-.26-.05-.36-.14h-.36v-1.93h0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "m9.16,27.31h-.16v.37h.36c-.1-.09-.17-.22-.2-.37"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m9.15,26.57h-.15v.73h.16s0-.06,0-.09v-.64"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m9.02,26.44h-.02v.13h.15v-.03s-.02,0-.03,0c-.04,0-.07,0-.1,0v-.09"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m9,25.74v.7h.02v-.68s-.01-.01-.02-.02"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "m19.04,16.75h-.37s.37,0,.37,0h0m-1.02-8.49v.11h.39c-.12-.06-.25-.1-.39-.11"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "m19.04,25.12h-.37v1.49s0,.03,0,.04c.23-.22.37-.54.38-.89h0v-.63"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-20",
    points: "19.04 16.75 18.66 16.75 18.66 25.12 19.04 25.12 19.04 16.75"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m18.4,8.38h-.39v.03c.19.16.32.34.32.55v.52c.2.22.33.52.33.85v6.43h.37v-7.29c0-.48-.26-.89-.63-1.08"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m9.15,26.44h-.14v.09s.07,0,.1,0c.01,0,.02,0,.03,0v-.1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m9.02,25.76v.68h.14v-.59s-.1-.06-.14-.09"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m9,7.4c-.1.11-.17.26-.17.42v17.49c0,.17.07.32.17.43v-.39c-.06-.09-.09-.21-.09-.33v-.3h0v-.31h0v-2.45h.09V7.4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "m9.02,7.39s-.01.01-.02.02v14.57-5.22h0V7.73h.02v-.34"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "9 21.97 8.91 21.97 8.91 24.42 8.91 24.42 8.91 22.28 9 22.28 9 21.97"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-49",
    points: "9.02 7.73 9 7.73 9 8.38 9 8.08 9.02 8.08 9.02 7.73"
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-59",
    points: "9.02 8.08 9 8.08 9 8.38 9.02 8.38 9.02 8.08"
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-98",
    points: "9.02 8.38 9 8.38 9 8.89 9 8.47 9.02 8.47 9.02 8.38"
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "9.02 8.47 9 8.47 9 8.89 9.02 8.89 9.02 8.47"
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-34",
    points: "9.02 8.89 9 8.89 9 9.41 9.02 9.41 9.02 8.89"
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-16",
    points: "9.02 9.41 9 9.41 9 9.99 9.02 9.99 9.02 9.41"
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-135",
    points: "9.02 16.75 9 16.75 9 16.75 9.02 16.75 9.02 16.75"
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-108",
    points: "9.02 16.75 9 16.75 9 21.97 9.02 21.97 9.02 16.75"
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-22",
    points: "9.02 9.99 9 9.99 9 16.75 9.02 16.75 9.02 9.99"
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-108",
    points: "9.02 16.75 9.02 16.75 9.02 21.97 9 21.97 9 22.28 9.02 22.28 9.02 16.75"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m9,25.36v.39s.01.01.02.02v-.38s-.01-.02-.02-.03"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "m9.02,25.38v.38s.09.07.14.09v-.33c-.05-.04-.1-.08-.14-.14"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "m18.01,8.41v.44c.08.14.13.3.15.47.06.04.12.1.17.15v-.52c0-.21-.13-.39-.32-.55"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "m18.01,8.86v.38c.05.03.1.06.15.09-.02-.17-.07-.33-.15-.47"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "m18.47,27.29c-.11.04-.22.06-.34.06h-.15v.3s0,.05,0,.08c.2-.09.37-.24.49-.43"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "m17.98,27.35h-.03c-.03.16-.08.3-.15.44.06-.02.12-.04.17-.06,0-.03,0-.05,0-.08v-.3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "m18.62,26.91c-.15.08-.32.13-.49.13h-.15v.03h0v.28h.15c.12,0,.23-.02.34-.06.07-.11.12-.24.16-.37"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "m17.98,27.07c0,.1-.01.19-.03.28h.03v-.28"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "m18.66,26.67s-.01,0-.02,0c-.18.17-.41.27-.66.28v.09h.15c.18,0,.34-.05.49-.13.02-.08.03-.16.04-.25"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "m18.66,26.65s-.01.01-.02.02c0,0,.01,0,.02,0,0,0,0-.01,0-.02"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "m17.95,27.35h-.2c-.11.19-.25.34-.42.47h.22c.09,0,.17-.01.25-.03.07-.13.12-.28.15-.44"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m17.75,27.35h-.34c-.25.21-.56.33-.89.33h-7.15c.1.09.22.14.36.14h7.6c.17-.12.31-.28.42-.47"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "m17.98,27.04h-.09c-.04.11-.08.21-.14.31h.2c.02-.09.03-.18.03-.28v-.03"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "m17.89,27.04h-.2c-.08.12-.18.22-.28.31h.34c.06-.1.1-.2.14-.31"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m17.98,26.95s-.03,0-.05,0h-.02s-.02.06-.03.09h.09v-.09"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "m17.92,26.95h-.17s-.04.06-.06.09h.2s.02-.06.03-.09"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "m10.06,27.31h-.9c.02.15.1.28.2.37h7.15c.33,0,.64-.12.89-.33h-7.14c-.07,0-.13-.01-.19-.04"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "m17.68,27.04h-.35c-.23.17-.51.27-.81.27h-6.46c.06.02.13.04.19.04h7.14c.11-.09.2-.19.28-.31"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m17.74,26.95h-.3s-.07.06-.11.09h.35s.04-.06.06-.09"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m9.57,26.57h-.42v.64s0,.06,0,.09h.9c-.19-.08-.34-.28-.35-.51-.06-.06-.11-.14-.14-.22"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m9.71,26.79c.02.24.16.43.35.51h6.46c.3,0,.58-.1.81-.27h-7.05c-.11,0-.22-.04-.3-.1-.1-.02-.19-.07-.27-.14"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m9.98,26.94c.09.06.19.1.3.1h7.05s.07-.06.11-.09h-7.36s-.07,0-.11-.01"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m9.56,26.53h-.33s-.05,0-.07,0v.03h.42s0-.03-.01-.04"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "m18.64,26.67s-.05,0-.07,0h-.59v.28c.25-.01.48-.11.66-.28"
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-172",
    points: "18.66 16.75 18.33 16.75 18.33 16.75 18.66 16.75 18.66 16.75"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "m18.66,25.12h-.4c-.02.07-.06.14-.09.21h0c0,.25-.07.48-.19.67v.13h0v.54h.59s.05,0,.07,0c0,0,.01-.01.02-.02,0-.01,0-.03,0-.04v-1.49"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m18.66,16.75h-.33v7.96c0,.14-.03.28-.07.41h.4v-8.37"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m18.33,9.48v7.28h.33v-6.43c0-.33-.13-.63-.33-.85"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "m17.98,26.67h0c0,.1-.03.19-.05.28h.02s.03,0,.05,0v-.28"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "m17.98,26.53s0,.09,0,.14h0v-.14"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m17.97,26.67h-.09c-.04.1-.08.19-.13.28h.17c.02-.09.04-.18.05-.28"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m17.98,26.13c0,.19-.04.38-.1.54h.09s0-.09,0-.14v-.41"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m17.87,26.67h-.19c-.07.1-.15.2-.25.28h.3c.05-.09.1-.18.13-.28"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m17.98,26s-.02.03-.03.05c-.04.23-.13.44-.26.62h.19c.06-.17.1-.35.1-.54v-.13"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m9.71,26.57h-.14c.03.08.08.16.14.22,0-.01,0-.03,0-.04v-.18"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m9.75,26.57h-.04v.18s0,.03,0,.04c.07.07.17.13.27.15-.12-.08-.2-.21-.23-.37"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m10.44,26.57h-.69c.03.15.12.28.23.37.03,0,.07.01.1.01h7.36c.09-.08.17-.18.25-.28h-6.95c-.11,0-.21-.04-.3-.1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m17.95,26.05c-.2.29-.53.48-.89.48h-.19c-.11.03-.22.04-.33.04-.02,0-.04,0-.06,0h-6.04c.09.06.19.1.3.1h6.95c.13-.18.22-.39.26-.62"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m9.71,26.53h-.15s0,.03.01.04h.14v-.04"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "m9.74,26.53h-.03v.04h.04s0-.03,0-.04"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m10.39,26.53h-.65s0,.03,0,.04h.69s-.04-.03-.05-.04"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "m16.87,26.53h-6.48s.03.03.05.04h6.04s.04,0,.06,0c.11,0,.23-.02.33-.04"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m9.54,26.44h-.38v.1s.05,0,.07,0h.33s-.02-.06-.02-.09"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m9.15,25.86v.59h.38s0-.06,0-.09v-.45h-.15c-.08,0-.16-.02-.23-.05"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m18.17,25.33c-.05.09-.12.18-.19.25v.42c.12-.19.19-.42.19-.67h0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m17.98,25.77c0,.1-.01.19-.03.28.01-.02.02-.03.03-.05v-.23"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m17.98,25.58s-.09.08-.14.12c-.19.41-.55.72-.97.83h.19c.36,0,.69-.19.89-.48.02-.09.03-.18.03-.28v-.19"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m9.71,26.44h-.17s.01.06.02.09h.15v-.09"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m9.74,26.44h-.03v.09h.03s0-.06,0-.09h0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m10.31,26.44h-.57s0,.06,0,.09h.65s-.06-.06-.08-.09"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m17.84,25.7s-.07.05-.11.07c-.27.41-.71.67-1.2.67-.02,0-.03,0-.05,0h-6.17s.05.06.08.09h6.48c.42-.11.78-.41.97-.83"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m9.71,25.91h-.18v.45s0,.06,0,.09h.17v-.54"
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-93",
    points: "9.74 25.91 9.71 25.91 9.71 26.44 9.74 26.44 9.74 25.91"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "m10.18,25.91h-.44v.54h.57c-.08-.1-.12-.23-.13-.37v-.17"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m17.73,25.78c-.15.08-.32.13-.51.13h-7.04v.17c0,.14.05.27.13.37h6.17s.03,0,.05,0c.49,0,.93-.26,1.2-.67"
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-156",
    points: "18.33 16.75 18.17 16.75 18.17 16.75 18.33 16.75 18.33 16.75"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "m18.26,25.12h-.09v.21c.04-.06.07-.13.09-.21"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "m18.33,16.75h-.16v8.37h.09c.04-.13.07-.26.07-.41v-7.96"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "m18.16,9.32s0,.09,0,.14v7.29h.16v-7.28c-.05-.06-.11-.11-.17-.15"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m9.15,25.52v.33c.07.03.15.05.23.05h.15v-.3h-.07s0,.01,0,.01c-.11,0-.21-.04-.3-.1"
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-43",
    points: "18.17 16.75 18.01 16.75 18.01 16.75 18.17 16.75 18.17 16.75"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m18.17,25.12h-.18s0,.08-.01.12v.34c.07-.07.14-.16.19-.25v-.21"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "m18.17,16.75h-.15v6.42s0,.08-.02.12v1.66h0s0,.07,0,.1c0,.03,0,.05,0,.08h.18v-8.37"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m18.01,9.24v7.52h.15v-7.29s0-.09,0-.14c-.05-.03-.1-.06-.15-.09"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m17.99,25.12h-.01v.12s0-.08.01-.12"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "m18,24.95c0,.06,0,.12-.02.17h0s.01,0,.01,0c0-.03,0-.05,0-.08,0-.04,0-.07,0-.1h0"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m18,23.29s-.01.03-.02.05v1.78c0-.06.01-.11.02-.17v-1.66"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m17.98,25.24c-.02.16-.07.32-.14.46.05-.04.09-.08.14-.12v-.34"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m17.98,25.12h0c-.04.24-.13.46-.25.65.04-.02.08-.05.11-.07.07-.14.11-.3.14-.46v-.12"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m17.98,25.12s0,0,0,0h0"
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-94",
    points: "9.71 25.57 9.53 25.61 9.53 25.91 9.71 25.91 9.71 25.57"
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "9.74 25.57 9.71 25.57 9.71 25.91 9.74 25.91 9.74 25.57"
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "10.18 25.48 9.74 25.57 9.74 25.91 10.18 25.91 10.18 25.48"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m17.98,25.12h-5.95l-1.85.36v.43h7.05c.18,0,.35-.05.51-.13.12-.19.21-.41.25-.65"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m17.98,23.34c-.25.59-1.69,1.07-2.25,1.07l-3.7.72h5.95s0,0,0,0v-1.78"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "m16.89,6.64h-7.88v.75h0v-.41h1.37c.09-.08.22-.13.34-.13h6.79c-.18-.13-.4-.21-.63-.21"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "m10.73,6.84c-.13,0-.25.05-.34.13h6.47s.03,0,.05,0c.25,0,.49.09.68.25h.27c-.08-.15-.2-.28-.33-.38h-6.78s0,0,0,0"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "m17.85,7.22h-.27c.15.13.28.3.35.5h.08c-.02-.18-.07-.35-.16-.5"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "m18.01,7.72h-.08c.05.13.08.27.08.42v-.32s0-.07,0-.1"
  })), _polyline25 || (_polyline25 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "9 22.28 8.91 22.28 8.91 24.42 8.91 24.42 8.91 22.58 9 22.58 9 22.28"
  })), _polyline26 || (_polyline26 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-106",
    points: "9.02 16.75 9.02 16.75 9.02 22.28 9 22.28 9 22.58 9.02 22.58 9.02 16.75"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m8.91,24.73v.3c0,.12.03.24.09.33v-.3c-.06-.09-.09-.21-.09-.33"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m9.02,25.12h-.02v.23s.01.02.02.03v-.26"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m9,25.06v.07h.02v-.04s-.01-.02-.02-.03"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m9.05,25.12h-.03v.26c.04.05.08.1.14.14v-.3s-.08-.06-.11-.1"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m9.02,25.09v.04h.03s-.02-.03-.03-.04"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m9.15,25.23v.3c.09.06.19.1.3.1h.07v-.31h-.07s0,.01,0,.01c-.11,0-.21-.04-.3-.1"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "m18.01,16.75h0v6.12s0,.08-.02.12v.3s.02-.08.02-.12v-6.42"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "m18,22.99s-.01.03-.02.05v.3s.01-.03.02-.05v-.3"
  })), _polyline27 || (_polyline27 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "9.71 25.28 9.53 25.31 9.53 25.61 9.71 25.57 9.71 25.28"
  })), _polyline28 || (_polyline28 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "9.74 25.27 9.71 25.28 9.71 25.57 9.74 25.57 9.74 25.27"
  })), _polyline29 || (_polyline29 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "10.18 25.19 9.74 25.27 9.74 25.57 10.18 25.48 10.18 25.19"
  })), _polyline30 || (_polyline30 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "12.02 25.12 10.49 25.12 10.18 25.19 10.18 25.48 12.02 25.12"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m17.98,23.05c-.25.59-1.69,1.07-2.25,1.07l-5.23,1.01h1.54l3.7-.72c.57,0,2.01-.48,2.25-1.07v-.3"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "m10.39,6.97h-1.37v.41c.1-.1.23-.15.37-.15h.8s.02,0,.03,0c.04-.1.1-.19.17-.25"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "m16.9,6.97s-.03,0-.05,0h-.01s0,0,0,0h-6.45c-.08.07-.14.15-.17.25.02,0,.05,0,.07,0h7.29c-.19-.16-.42-.25-.68-.25"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "m10.21,7.23s-.02,0-.03,0h.03s0,0,0,0"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m10.28,7.22s-.05,0-.07,0c0,0,0,0,0,0h4.86c.55,0,1.08.15,1.57.42.02.02.05.04.09.07h1.2c-.08-.2-.2-.37-.35-.5h-7.3"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m17.93,7.72h-1.2s.04.02.06.03c.23.04.45.15.63.3.13.07.27.14.39.22h.12s.06,0,.09,0v-.13c0-.15-.04-.29-.08-.42"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m16.79,7.75c.15.08.38.18.63.3-.18-.15-.4-.25-.63-.3"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "m17.92,8.26h-.12c.06.04.12.08.17.12h.04v-.11s-.06,0-.09,0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m18.01,8.38h-.04s.03.02.04.03v-.03"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "m10.19,7.23h-.8c-.14,0-.27.06-.37.15v.34h.73c.04-.25.22-.45.44-.5"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "m10.21,7.23h-.03c-.23.05-.41.24-.44.5h.42s0,0,.01,0v-.29c0-.07.02-.14.04-.21"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "m15.08,7.23h-4.86c-.02.06-.04.14-.04.21v.29s.06,0,.09,0h6.47s-.07-.05-.09-.07c-.49-.27-1.02-.41-1.57-.42"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "m10.18,7.73s0,0-.01,0h.01"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "m17.42,8.05c.08.06.15.14.21.22h.18c-.12-.08-.26-.15-.39-.22m-7.15-.33s-.06,0-.09,0h0s6.31,0,6.31,0h.01s.03,0,.05,0c.09,0,.17,0,.25.02-.02-.01-.04-.02-.06-.03h-6.46s0,0,0,0"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m8.91,24.42v.31c0,.12.03.24.09.33v-.31c-.06-.09-.09-.21-.09-.33"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m9,22.58h-.09v1.85c0,.12.03.24.09.33v-2.18"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m9.74,7.73h-.73v.36h.72v-.27h0s0-.06,0-.09"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m10.16,7.73h-.42s0,.05,0,.08h0v.28h.02c.07-.18.22-.32.41-.36"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m10.18,7.73h-.01c-.18.04-.34.17-.41.36h.42v-.36"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m16.54,7.73s-.03,0-.05,0h-6.32v.36h6.32s.01,0,.02,0c.24,0,.47.06.67.18h.44c-.06-.08-.14-.15-.21-.22-.24-.12-.48-.22-.63-.3-.08-.02-.17-.02-.25-.02"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "m9.74,8.08h-.72v.3h0v-.12s.07-.01.1-.01.07,0,.1.01h.49s.01-.09.02-.13v-.05"
  })), _polyline31 || (_polyline31 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-21",
    points: "9.02 8.38 9.02 8.38 9.02 8.47 9.02 8.47 9.02 8.38"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "m9.75,8.08h-.02v.05s.01-.03.02-.05"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "m9.74,8.13s-.02.08-.02.13h.02v-.13"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "m10.18,8.08h-.42s-.01.03-.02.05v.13h.44v-.18"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "m16.52,8.08h-.04s-6.31,0-6.31,0v.18h7.02c-.2-.11-.43-.18-.67-.18"
  })), _polyline32 || (_polyline32 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-33",
    points: "9.02 8.47 9.02 8.47 9.02 8.89 9.02 8.89 9.02 8.47"
  })), _polyline33 || (_polyline33 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-23",
    points: "9.02 8.89 9.02 8.89 9.02 9.41 9.02 9.41 9.02 8.89"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m9,24.75v.31s.01.02.02.03v-.31s-.01-.02-.02-.03"
  })), _polyline34 || (_polyline34 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-26",
    points: "9.02 9.41 9.02 9.41 9.02 9.99 9.02 9.99 9.02 9.41"
  })), _polyline35 || (_polyline35 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-116",
    points: "9.02 16.75 9.02 16.75 9.02 16.75 9.02 16.75 9.02 16.75"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "m9.02,16.75h0v5.82h-.02v2.18s.01.02.02.03v-8.02"
  })), _polyline36 || (_polyline36 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "9.02 9.99 9.02 9.99 9.02 16.75 9.02 16.75 9.02 9.99"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "m17.81,8.26h-.18s.06.08.09.12h.26c-.05-.04-.11-.08-.17-.12"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "m17.98,8.38h-.26c.05.08.1.16.14.25.06.07.11.14.16.23v-.44s-.02-.02-.04-.03"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "m17.63,8.26h-.44s.01,0,.02.01c.11.02.22.05.32.11h.18s-.06-.08-.09-.12"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m17.72,8.38h-.18c.12.06.23.15.32.25-.04-.09-.08-.17-.14-.25"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "m17.19,8.26h-.13c.05,0,.1,0,.15.01,0,0-.01,0-.02-.01"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "m9.12,8.25s-.07,0-.1.01v.12h.69v-.07s0-.03,0-.05h-.49s-.07-.01-.11-.01"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m9.71,8.38h-.69v.09h.65s.03-.03.04-.05v-.04"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "m9.74,8.26h-.02s0,.03,0,.05v.07h.03v-.12"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m9.74,8.38h-.03v.04s.02-.02.03-.03h0"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "m10.08,8.26h-.34v.12h.02c.09-.07.2-.12.32-.12"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m9.75,8.38h-.02s.01,0,.02,0"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m9.66,8.47h-.65v.42h.51v-.03c0-.15.05-.28.14-.39"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m9.53,8.89h-.51v.53h.22c.07-.12.17-.2.29-.25v-.27"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m9.15,25.12h-.11s.07.07.11.1v-.1"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m9.02,24.78v.31s.02.03.03.04h.11v-.21c-.05-.04-.1-.09-.14-.14"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m9.24,9.41h-.22v.57h.14v-.27c0-.11.03-.22.09-.31"
  })), _polyline37 || (_polyline37 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-41",
    points: "9.15 16.75 9.02 16.75 9.02 16.75 9.15 16.75 9.15 16.75"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m9.15,16.75h-.14v8.03c.04.05.08.1.14.14v-8.16"
  })), _polyline38 || (_polyline38 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-27",
    points: "9.15 9.99 9.02 9.99 9.02 16.75 9.15 16.75 9.15 9.99"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m17.86,8.63c.08.18.13.38.14.59,0,0,.01,0,.02,0v-.38c-.04-.08-.1-.16-.16-.23"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "m17.21,8.28c.05.03.11.07.16.11h.17c-.1-.05-.21-.09-.32-.11"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m17.54,8.38h-.17c.25.2.44.48.54.81.03.01.06.02.08.04-.01-.21-.06-.41-.14-.59-.09-.1-.2-.19-.32-.25"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m9.71,8.42s-.03.03-.04.05h.04v-.05"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m9.74,8.4s-.02.02-.03.03v.05h.03v-.08"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "m10.18,8.26h-.1c-.12,0-.23.05-.32.12h.42v-.12"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m10.18,8.38h-.42s-.01,0-.02.01v.08h.44v-.09"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "m17.06,8.26h-6.89v.12h7.19c-.05-.04-.1-.08-.16-.11-.05,0-.1-.01-.15-.01"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m17.37,8.38h-7.19v.09h6.35c.49,0,.92.27,1.18.67.07.01.14.03.2.05-.1-.33-.29-.61-.54-.81"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m9.71,8.47h-.04c-.08.1-.13.24-.14.39v.03h.18v-.42"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m9.71,8.89h-.18v.27c.06-.02.12-.03.18-.04v-.24"
  })), _polyline39 || (_polyline39 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-26",
    points: "9.74 8.47 9.71 8.47 9.71 8.89 9.74 8.89 9.74 8.47"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m9.74,8.89h-.03v.24h.03v-.24"
  })), _polyline40 || (_polyline40 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-30",
    points: "10.18 8.47 9.74 8.47 9.74 8.89 10.18 8.89 10.18 8.47"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m16.53,8.47h-6.35v.42h6.34c.28,0,.55.09.77.24h.25s0,0,0,0c.05,0,.11,0,.16.01-.26-.4-.69-.66-1.18-.67"
  })), _polyline41 || (_polyline41 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-27",
    points: "10.18 8.89 9.74 8.89 9.74 9.13 10.18 9.13 10.18 8.89"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m16.52,8.89h-6.34v.24h7.11c-.22-.15-.49-.24-.77-.24"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m9.53,9.16c-.12.05-.22.14-.29.25h.29v-.25"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m9.53,25.12h-.37v.1c.09.06.19.1.3.1h.07v-.2"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m9.15,24.92v.21h.37v-.12h-.07s0,.01,0,.01c-.11,0-.21-.04-.3-.1"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m9.53,9.41h-.29c-.05.09-.08.19-.09.31v.27h.37v-.57"
  })), _polyline42 || (_polyline42 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-42",
    points: "9.53 16.75 9.15 16.75 9.15 16.75 9.53 16.75 9.53 16.75"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m9.53,16.75h-.37v8.16c.09.06.19.1.3.1h.07v-8.26"
  })), _polyline43 || (_polyline43 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-28",
    points: "9.53 9.99 9.15 9.99 9.15 16.75 9.53 16.75 9.53 9.99"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "m18.01,16.75h0v5.81s0,.08-.02.12v.31s.02-.08.02-.12v-6.12"
  })), _polyline44 || (_polyline44 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-57",
    points: "18.01 16.75 18 16.75 18 16.75 18.01 16.75 18.01 16.75"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "m18.01,16.75h-.02v5.93s.02-.08.02-.12v-5.81"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m17.99,9.23s0,.03,0,.04v7.49h.02v-7.52s-.01,0-.02,0"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "m18,22.69s-.01.03-.02.05v.31s.01-.03.02-.05v-.31"
  })), _polyline45 || (_polyline45 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-132",
    points: "18 16.75 17.98 16.75 17.98 16.75 18 16.75 18 16.75"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "m18,16.75h-.02v5.98s.01-.03.02-.05v-5.93"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m17.91,9.19c.04.15.07.3.07.46v7.1h.02v-7.49s0-.03,0-.04c-.03-.02-.06-.03-.08-.04"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m17.71,9.14c.17.26.27.57.27.91v-.4c0-.16-.03-.32-.07-.46-.06-.02-.13-.04-.2-.05"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m9.71,9.13c-.06,0-.12.01-.18.04v.25h.18v-.29"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m9.74,9.13h-.03v.29h.03v-.29"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m17.55,9.13h0s-.25,0-.25,0c.4.27.67.75.69,1.3v.53h0v5.8-6.7c0-.34-.1-.65-.27-.91-.05,0-.1-.01-.16-.01"
  })), _polyline46 || (_polyline46 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-28",
    points: "10.18 9.13 9.74 9.13 9.74 9.41 10.18 9.41 10.18 9.13"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m17.29,9.13h-7.11v.29h6.34c.79,0,1.43.68,1.46,1.54v-.53c-.02-.55-.29-1.03-.69-1.3"
  })), _polyline47 || (_polyline47 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "9.71 25.12 9.53 25.12 9.53 25.31 9.71 25.28 9.71 25.12"
  })), _polyline48 || (_polyline48 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-68",
    points: "9.71 24.97 9.53 25 9.53 25.12 9.71 25.12 9.71 24.97"
  })), _polyline49 || (_polyline49 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "9.74 25.12 9.71 25.12 9.71 25.28 9.74 25.27 9.74 25.12"
  })), _polyline50 || (_polyline50 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-64",
    points: "9.74 24.96 9.71 24.97 9.71 25.12 9.74 25.12 9.74 24.96"
  })), _polyline51 || (_polyline51 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "10.18 25.12 9.74 25.12 9.74 25.27 10.18 25.19 10.18 25.12"
  })), _polyline52 || (_polyline52 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-65",
    points: "10.18 24.88 9.74 24.96 9.74 25.12 10.18 25.12 10.18 24.88"
  })), _polyline53 || (_polyline53 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "10.49 25.12 10.18 25.12 10.18 25.19 10.49 25.12"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m17.98,22.74c-.25.59-1.69,1.06-2.25,1.06l-5.55,1.08v.25h.31l5.23-1.01c.57,0,2.01-.48,2.25-1.07v-.31"
  })), _polyline54 || (_polyline54 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-28",
    points: "9.71 9.41 9.53 9.41 9.53 9.99 9.71 9.99 9.71 9.41"
  })), _polyline55 || (_polyline55 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-40",
    points: "9.71 16.75 9.53 16.75 9.53 16.75 9.71 16.75 9.71 16.75"
  })), _polyline56 || (_polyline56 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-68",
    points: "9.71 16.75 9.53 16.75 9.53 25 9.71 24.97 9.71 16.75"
  })), _polyline57 || (_polyline57 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-32",
    points: "9.71 9.99 9.53 9.99 9.53 16.75 9.71 16.75 9.71 9.99"
  })), _polyline58 || (_polyline58 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-32",
    points: "9.74 9.41 9.71 9.41 9.71 9.99 9.74 9.99 9.74 9.41"
  })), _polyline59 || (_polyline59 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-46",
    points: "9.74 16.75 9.71 16.75 9.71 16.75 9.74 16.75 9.74 16.75"
  })), _polyline60 || (_polyline60 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-64",
    points: "9.74 16.75 9.71 16.75 9.71 24.97 9.74 24.96 9.74 16.75"
  })), _polyline61 || (_polyline61 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-31",
    points: "9.74 9.99 9.71 9.99 9.71 16.75 9.74 16.75 9.74 9.99"
  })), _polyline62 || (_polyline62 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-31",
    points: "10.18 9.41 9.74 9.41 9.74 9.99 10.18 9.99 10.18 9.41"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m16.52,9.41h-6.34v.57h6.31s.03,0,.04,0c.77,0,1.41.66,1.46,1.5v5.27-5.8c-.02-.86-.67-1.54-1.46-1.54"
  })), _polyline63 || (_polyline63 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-45",
    points: "10.18 16.75 9.74 16.75 9.74 16.75 10.18 16.75 10.18 16.75"
  })), _polyline64 || (_polyline64 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-65",
    points: "10.18 16.75 9.74 16.75 9.74 24.96 10.18 24.88 10.18 16.75"
  })), _polyline65 || (_polyline65 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-38",
    points: "10.18 9.99 9.74 9.99 9.74 16.75 10.18 16.75 10.18 9.99"
  })), _polyline66 || (_polyline66 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-45",
    points: "17.98 16.75 10.18 16.75 10.18 16.75 17.98 16.75 17.98 16.75"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m17.98,16.75h-7.8v8.12l5.55-1.08c.57,0,2.01-.47,2.25-1.06v-5.98"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "m16.52,9.99s-.03,0-.04,0h-6.31v6.76h7.8v-5.27c-.04-.84-.69-1.5-1.46-1.5"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "m1.5,7.18h14.98c.82,0,1.49.71,1.5,1.6v15.94c0,.89-.67,1.61-1.5,1.61H1.5c-.4,0-.77-.18-1.06-.48C.16,25.55,0,25.14,0,24.72v-15.95c.01-.89.68-1.59,1.5-1.59Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "13.61 21.74 11.59 21.74 9.23 14.86 6.75 21.74 4.73 21.74 2.47 11.76 4.5 11.76 6.07 18.75 8.43 11.96 10.12 11.96 12.37 18.75 13.94 11.76 15.86 11.76 13.61 21.74"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWord);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/word.4f092d3c6ab78d39a255794d09dc5547.svg";